import withNetworkProvider from '../../containers/withNetworkProvider'

import App from './App'

export default withNetworkProvider(App)
